import { ProfilePackingListColumn } from "src/app/domain/models/Profile";

export const DefaultProfilePackingListColumnDefault: ProfilePackingListColumn = {
  packingDateColumn: true,
  producerColumn: true,
  csgColumn: true,
  cspColumn: true,
  bagTypeColumn: true,
  packagingColumn: true,
  netWeightColumn: true,
  fridgeStorageColumn: true,
  boxSizeColumn: true,
  labelColumn: true,
  categoryColumn: true,
  gradeColumn: true,
  temptaleColumn: true,
  cooColumn: true,
};

export interface  ProfilePackingListColumnLabels {
  [key: string]: {name:string, nameEs: string}
}

export const ProfilePackingListColumnLabels: ProfilePackingListColumnLabels  = {
  packingDateColumn: {name:"Packing Date", nameEs: 'Fecha embalaje'},
  producerColumn: {name:"Grower", nameEs: 'Productor'},
  csgColumn: {name:"CSG", nameEs: 'CSG'},
  cspColumn: {name:"CSP", nameEs: 'CSP'},
  bagTypeColumn: {name: "Bag Type", nameEs: 'Tipo de Bolsa'},
  packagingColumn: {name:"Packaging", nameEs: 'Embalaje'},
  netWeightColumn: {name:"Net Weight", nameEs: 'Peso Neto'},
  fridgeStorageColumn: {name:"ColdStorage", nameEs: 'Frigorífico'},
  boxSizeColumn: {name:"Box Size", nameEs: 'Tamaño de caja'},
  labelColumn: {name:"Label", nameEs: 'Etiqueta'},
  categoryColumn: {name:"Category", nameEs: 'Categoría'},
  gradeColumn: {name:"Grade", nameEs: 'Grado'},
  temptaleColumn: {name:"Temptale", nameEs: 'Termografo'},
  cooColumn: {name:"Origin Country", nameEs: 'País Origen'}
};


